module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amount":"@:labels.amount","title":"@:labels.assets","type":"@:labels.type"},"fr":{"amount":"@:labels.amount","title":"@:labels.assets","type":"@:labels.type"}}')
  delete Component.options._Ctor
}
